<template>
  <div class="activity-indicator flex-center">
    <div class="row">
      <div class="col-12 d-flex justify-content-center">
        <div class="icon--loading"
             role="progressbar"
             aria-label="Processing Spinner">
        </div>
      </div>
      <div class="col text-28 text-600 text-center">
        {{ $t('processing') }}...
      </div>
    </div>
  </div>
</template>

<script>
// Utilities
import Logger from '../../../utility/loggerUtil'

export default {
  name: 'activity-indicator',

  mounted () {
    try {
      document.body.insertBefore(this.$el, document.body.firstChild)
    } catch (e) {
      Logger.error('Failed to move activity indicator')
      Logger.debug(e)
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../../assets/styles/colors';

.activity-indicator {
  position: fixed;
  z-index: 9999; /* Bootstrap modals use z-index of 1024 */
  width: 100%;
  height: 100%;
  background-color: colors.$white-50op;
}

.icon--loading {
  width: 3.75rem;
  height: 3.75rem;
  border: 0.313rem solid;
  border-left: 0.313rem solid transparent !important;
  border-radius: 50%;
  -ms-animation: spin 1.5s linear infinite;
  -webkit-animation: spin 1.5s linear infinite;
  -moz-animation: spin 1.5s linear infinite;
  animation: spin 1.5s linear infinite;

  .c1l & {
    border-color: colors.$c1l--green-3;
  }

  .ccc & {
    border-color: colors.$ccc--blue-2;
  }

  .ccf & {
    border-color: colors.$ccf--blue-5;
  }

  .chs & {
    border-color: colors.$chs--green-2;
  }

  .cic & {
    border-color: colors.$cic--green-3;
  }

  .esm & {
    border-color: colors.$esm--green-2;
  }

  .inl & {
    border-color: colors.$inl--green-1;
  }

  .tbs & {
    border-color: colors.$tbs--green-3;
  }

  .tmx & {
    border-color: colors.$tmx--blue-1;
  }
}

@-ms-keyframes spin {
  from { -ms-transform: rotate(0deg); }
  to { -ms-transform: rotate(360deg); }
}

@-moz-keyframes spin {
  from { -moz-transform: rotate(0deg); }
  to { -moz-transform: rotate(360deg); }
}

@-webkit-keyframes spin {
  from { -webkit-transform: rotate(0deg); }
  to { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>

<i18n>
{
  "en": {
    "processing": "Processing"
  }
}
</i18n>
